/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-08-03 13:37:10
 * @LastEditTime : 2023-09-15 10:13:26
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_change\src\api\basicConfig\carInnerOut.js
 */
import request from '@/utils/request'

export const queryPage ='/icps/system/sign/intelligent/OutAndIn/queryWeightTankCar'
export const downloadURL ='/icps/system/sign/intelligent/OutAndIn/exportWeightCarTank'
//删除
export function deleteWeight(data) {
	return request({
		url: '/icps/system/sign/intelligent/OutAndIn/deleteWeight',
		method: 'post',
		data
	})
}